import { useModal } from '@ebay/nice-modal-react';
import { useRouter } from 'next/router';

import { logger } from '@zep/core-logger';
import { useViewportDevice } from '@zep/react';
import { CreateSpaceFunnel } from '@zep/web-components';

import { EnterCodeModal } from '../../components/service';

export const useModalActions = () => {
  const router = useRouter();
  const { isMobile } = useViewportDevice();
  const enterCodeModal = useModal(EnterCodeModal);
  const createSpaceFunnel = useModal(CreateSpaceFunnel);

  const handleClickEnterWithCode = () => {
    enterCodeModal.show();
    logger.track('home_enter_code');
  };

  const handleClickCreateSpace = () => {
    if (isMobile) {
      createSpaceFunnel.show({ from: 'home' });
    } else {
      router.push('/home/create');
    }
    logger.track('home_create_space');
  };

  return { handleClickEnterWithCode, handleClickCreateSpace };
};
